import React from "react";
import LogoWhiteImg from "./logo-white.png";
function LogoWhite() {
  return <img src={LogoWhiteImg} alt="Logo White" width="70" height="50" />;
}

export default LogoWhite;
